export function setCircleMem(payload) {
  return {
    type: 'SET_CIRCLE_MEM',
    payload,
  };
}

export function setDepartIndex(payload) {
  return {
    type: 'SET_DEPART_INDEX',
    payload,
  };
}

const initialState = {
  allDepartName: '',
  allDeptCode: '',
  departIndex: '',
};

export default function circleMemInfo(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case 'SET_CIRCLE_MEM': {
      return { ...state, ...payload };
    }
    case 'SET_DEPART_INDEX': {
      return { ...state, ...payload };
    }
    default: {
      return state;
    }
  }
}
